import API from '../axios';

// Create a new booking (client)
export const createBooking = (bookingData) => API.post('/booking', bookingData);

// Get all bookings of the current user (or all non-guest if admin)
export const getMyBookings = () => API.get('/booking');

// Mark a booking as completed
export const completeBooking = (id) => API.put(`/booking/complete/${id}`);

// Delete a booking
export const deleteBooking = (id) => API.delete(`/booking/${id}`);

// Reduce the session count of a booking
export const reduceSession = (id) => API.put(`/booking/reduce-session/${id}`);

// Send email about the next session
export const sendNextSessionEmail = (bookingId, nextSession) =>
  API.post('/email/next-session', { bookingId, nextSession });

// ── Guest Bookings (Admin only) ──────────────────────────────────

// Admin creates a guest booking manually
export const createGuestBooking = (data) => API.post('/booking/guest', data);

// Admin fetches all guest bookings
export const getGuestBookings = () => API.get('/booking/guest');

// Admin reschedules a guest session
export const rescheduleGuestSession = (bookingId, newScheduledAt) =>
  API.put(`/booking/guest/reschedule/${bookingId}`, { newScheduledAt });